module.exports = __webpack_public_path__ + "media/sapa_archive/promo01-63d568ba.png";